import { FormSelectId, FormSelectIdProps } from '@nexelem/form-components';
import { useCustomTranslation } from '../../../hooks';
import { useCompetenceAuthorities } from '../../../queryHooks/competenceHooks';

type FormCompetenceAuthoritySelectProps = Omit<FormSelectIdProps, 'label' | 'options' | 'placeholder'>;

export const FormCompetenceAuthoritySelect = (props: FormCompetenceAuthoritySelectProps) => {
  const { t, tWrapper } = useCustomTranslation('workers.modals.addCompetence');
  const { data, isLoading } = useCompetenceAuthorities();

  const options = isLoading
    ? []
    : data?.map(({ id = 0, name }) => {
        return { id, label: name };
      });

  return (
    <FormSelectId
      {...props}
      label={tWrapper('examiner')}
      loading={isLoading}
      options={options}
      placeholder={t('components.filters.searchOrSelect')}
    />
  );
};
